/**
 * Quotation Variant Sync
 * Subscribes to the theme's variantChange pub/sub event and updates
 * hidden form fields + display spans in the quotation form.
 */
(function () {
  'use strict';

  function updateQuoteFields(event) {
    if (!event || !event.data) return;

    var variant = event.data.variant;
    var sectionId = event.data.sectionId || event.data.section_id || '';

    // Build a selector scope if we have a section ID
    var scope = sectionId
      ? document.querySelector('[data-section="' + sectionId + '"]') || document
      : document;

    if (!variant) return;

    // Update hidden inputs
    var fields = {
      'quote-variant-title': variant.title || '',
      'quote-sku': variant.sku || '',
      'quote-variant-id': variant.id || ''
    };

    Object.keys(fields).forEach(function (attr) {
      var el = scope.querySelector('[data-' + attr + ']');
      if (el) {
        el.value = fields[attr];
      }
    });

    // Update display spans
    var displayMap = {
      'quote-display-variant': variant.title || '',
      'quote-display-sku': variant.sku || ''
    };

    Object.keys(displayMap).forEach(function (attr) {
      var el = scope.querySelector('[data-' + attr + ']');
      if (el) {
        el.textContent = displayMap[attr];
      }
    });
  }

  // Wait for pub/sub to be available (scripts are deferred)
  function init() {
    if (
      typeof window.PUB_SUB_EVENTS !== 'undefined' &&
      typeof window.subscribe === 'function'
    ) {
      subscribe(PUB_SUB_EVENTS.variantChange, updateQuoteFields);
    } else {
      // Retry until pub/sub is ready
      setTimeout(init, 100);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
